import React from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation, useNavigate } from 'react-router-dom';
import { 
  Select, 
  MenuItem, 
  FormControl,
  InputLabel
} from '@mui/material';

const languages = [
  { code: 'en', name: 'English' },
  { code: 'es', name: 'Español' },
  { code: 'zh', name: '中文' },
  { code: 'hi', name: 'हिन्दी' },
  { code: 'ar', name: 'العربية' },
  { code: 'pt', name: 'Português' },
  { code: 'ru', name: 'Русский' },
  { code: 'ja', name: '日本語' },
  { code: 'he', name: 'עברית' },
  { code: 'de', name: 'Deutsch' },
  { code: 'it', name: 'Italiano' },
  { code: 'fr', name: 'Français' }
];

function LanguageSwitcher() {
  const { i18n, t } = useTranslation();
  const location = useLocation();
  const navigate = useNavigate();

  const handleChange = (event) => {
    const newLang = event.target.value;
    
    i18n.changeLanguage(newLang);
    document.dir = isRTL(newLang) ? 'rtl' : 'ltr';
    // Save language preference to localStorage
    localStorage.setItem('preferredLanguage', newLang);
    
    // Update the URL to reflect the new language using React Router navigation
    const currentPath = location.pathname;
    const pathSegments = currentPath.split('/');
    
    // If we're on a language-prefixed route, update the language part
    if (pathSegments.length > 1 && pathSegments[1] && pathSegments[1].length === 2) {
      // Replace the language part of the URL
      pathSegments[1] = newLang;
      const newPath = pathSegments.join('/');
      // Use React Router navigation instead of window.location.href
      navigate(newPath, { replace: true });
    } else {
      // If we're not on a language-prefixed route, redirect to the new language
      const currentPathWithoutLang = currentPath === '/' ? '' : currentPath;
      const newPath = `/${newLang}${currentPathWithoutLang}`;
      // Use React Router navigation instead of window.location.href
      navigate(newPath, { replace: true });
    }
  };

  const isRTL = (lang) => {
    return ['ar', 'he'].includes(lang);
  };

  return (
    <FormControl size="small" sx={{ minWidth: 120 }}>
      <InputLabel id="language-select-label" sx={{ fontWeight: 'bold' }}>{t('common.language')}</InputLabel>
      <Select
        labelId="language-select-label"
        id="language-select"
        value={i18n.language}
        label={t('common.language')}
        onChange={handleChange}
        sx={{ fontWeight: 'bold' }}
      >
        {languages.map((lang) => (
          <MenuItem key={lang.code} value={lang.code}>
            {lang.name}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
}

export default LanguageSwitcher; 